import {
    Component,
    OnDestroy
} from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { SocialListeningQuotaUsageWidgetComponent } from '../../../Shared/components/QuotaUsageWidget/social-listening-quota-usage-widget.component';
import { FullProfileAnimationModel } from '../../../../Core/Dialogs/models/full-profile-animation.model';
import { FullProfileDialogAnimationsEnum } from '../../../../Core/Dialogs/enums/full-profile-dialog-animations.enum';
import { OverlayAnimationStateEnum } from '../../../../Core/Dialogs/enums/overlay-animation.enum';
import { ThemeService } from '../../services/theme.service';
import { MonitoringQuotaTypesEnum } from '../../../../api/mentions/enum/monitoring-quota-types.enum';

@Component({
    selector: 'agpr-quota-usage-panel',
    templateUrl: './quota-usage-panel.component.html',
    styleUrls: ['./quota-usage-panel.component.scss'],
    standalone: false
})
export class QuotaUsagePanelComponent implements OnDestroy {

    public readonly buttonTypes = ButtonTypesEnum;
    public readonly quotaType = MonitoringQuotaTypesEnum.SOCIAL_LISTENING;
    public isPinned: boolean;
    private subscriptions: Subscription[] = [];


    constructor(
        public coreDialogService: CoreDialogService,
        public themeService: ThemeService,
    ) {

        this.subscriptions.push(
            this.themeService.getQuotaPanelVisibility().subscribe((pinnedState) => {
                this.isPinned = pinnedState;
            })
        );
    }

    openQuotaUsageWidget(): void {
        const animationTrigger = new BehaviorSubject(
            new FullProfileAnimationModel(
                FullProfileDialogAnimationsEnum.slideInOutAnimation,
                OverlayAnimationStateEnum.open
            )
        );
        const io = {
            inputs: {
                animationTrigger: animationTrigger,
                overlayContainer: document.getElementById('main-content')
            },
            outputs: {}
        };
        this.coreDialogService.open(SocialListeningQuotaUsageWidgetComponent, io);
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe);
    }
}
